
/**
 * order of preference
 * maxres & mq are first as they do not have black borders
 */
export const ytPreviewImgOrder = ['maxresdefault', 'mqdefault', 'sddefault', 'hqdefault', 'default'];

/**
 * get the src of the default youtube url preview image 
 * ! 'maxresdefault' is the highest quality image however is not available for all videos
 * @param {string} ytUrl youtube url
 * @param {'sddefault' | 'mqdefault' | 'hqdefault' | 'maxresdefault' | 'default' | '0' } quality image quality
 * @param {boolean} webp use webp image type
 * @returns {string} yt image src
 */
export const getYoutubePreviewImage = ( ytUrl, quality = 'maxresdefault', webp = false ) => {
  const videoId = ytUrl?.match( /(\?|&)v=([^&#]+)/ )?.pop();
  if (!videoId) return ''
  const ytPreviewSrc = `https://i.ytimg.com/${webp ? 'vi_webp' : 'vi'}/${ videoId }/${quality}.${webp ? 'webp' : 'jpg'}`;
  return ytPreviewSrc
}